export const postContentClass = "Content"
export const hasFocusClass = "ProseMirror-selectednode"
export const hideSelectionClass = "ProseMirror-hideselection"
export const editableSelector = `[contenteditable="true"]`
